import { render, staticRenderFns } from "./LookUserMessage.vue?vue&type=template&id=1539de96&scoped=true"
import script from "./LookUserMessage.vue?vue&type=script&lang=js"
export * from "./LookUserMessage.vue?vue&type=script&lang=js"
import style0 from "./LookUserMessage.vue?vue&type=style&index=0&id=1539de96&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1539de96",
  null
  
)

export default component.exports